export default {
  label: {
    title: {
      removeCards: 'Eliminar {count} componentes',
      removeCard: 'Eliminar {count} componente',
    },
    button: {
      cancel: 'Cancelar',
      remove: 'Eliminar',
    },
  },
};
